<template>
  <div ref="allpage">
    <search-modal
      ref="search"
      style="position: fixed; top: 0; width: 100%; z-index: 999"
      @toserch="toserch"
    />
    <md-tabs style="margin-top: 1rem" @change="changetable" v-model="indename">
      <md-tab-pane
        class="contentpack"
        name="0"
        :label="items[0].label"
        style="position: relative"
      >
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[0].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[0].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle">
                    <img
                      src="@/assets/image/icon_pack_drk.png"
                      alt=""
                    />
                    <span>{{ item.warehouse }}</span>
                  </div>
                  <span>待入庫</span>
                </div>
                <div class="pckdetail">
                  <p>
                    快遞單號:
                    <span v-if="item.expressCompany"
                  >{{ item.expressCompany }}-{{ item.expressNumber }}</span
                  >
                    <span v-else>{{ item.expressNumber }}</span>
                  </p>
                  <p v-if="item.remark">
                    包裹标注:
                    <span>{{ item.remark }}</span>
                  </p>
                  <p>
                    货物类型:
                    <span v-if="item.type===0" style="color: #2a78dc">普货</span>
                    <span v-else style="color: orangered">特货</span>
                  </p>
                  <p>
                    包裹總值:
                    <md-amount
                      :value="item.totalPrice"
                      has-separator
                    ></md-amount>
                    CNY
                  </p>
                  <p>
                    預報時間:<span>{{
                      item.createTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <div class="parcel_detail_container">
                    <p>包裹明細:</p>
                    <div class="tag_container">
                      <md-tag
                        v-for="(tag, tagIndex) in item.list"
                        :key="tagIndex"
                        size="small"
                        shape="circle"
                        type="ghost"
                        font-color="#FC7353"
                      >{{ tag.name }}x{{ tag.num }}
                      </md-tag
                      >
                    </div>
                  </div>
                </div>
                <div class="packopeartion">
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    @click="detail(item)"
                    v-if="item.status == 1"
                    round
                  >編輯
                  </md-button
                  >
                  <md-button
                    type="warning"
                    size="small"
                    inline
                    plain
                    style="margin-left: 0.2rem"
                    @click="delet(item, index)"
                    v-if="item.status == 1"
                    round
                  >删除
                  </md-button>
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    @click="chenkjfr(item)"
                    v-if="item.status == 2"
                    round
                    style="margin-left: 0.2rem"
                  >撤銷拒收
                  </md-button
                  >
                  <md-button
                    type="primary"
                    size="small"
                    inline
                    plain
                    @click="lanjie(item)"
                    v-if="item.status == 1 || item.status == 3"
                    round
                    style="margin-left: 0.2rem"
                  >拒收攔截
                  </md-button
                  >
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.2rem"
                    @click="lookwu(item)"
                    round
                  >查看物流
                  </md-button>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 3.4rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane class="contentpack" name="1" :label="items[1].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <md-drop-menu
              :data="warehouses"
              v-if="warehouses[0].options.length > 0"
              @change="changeWareHouse"
            />
            <div v-if="list[1].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[1].packlist"
                :key="index"
                class="packItem"
              >
                <md-check-group v-model="favorites" ref="checkList">
                  <div class="packcompany" @click="godetail(item)">
                    <div class="packtitle">
                      <img src="@/assets/image/icon_pack_drk.png" alt=""/>
                      <span>{{ item.warehouse }}</span>
                    </div>
                    <span v-if="item.status == 11" style="color: #32c5ea"
                    >待補資料</span
                    >
                    <span v-if="item.status == 12">待合包</span>
                    <span v-if="item.status == 13" style="color: #e51c23"
                    >超期</span
                    >
                    <span v-if="item.status == 14" style="color: #32c5ea"
                    >待補資料</span
                    >
                  </div>
                  <md-button
                    type="warning"
                    plain
                    v-if="item.status == 11 || item.status == 14"
                    style="width: 90%; height: 0.7rem; margin: 0.2rem 5%"
                    icon="info"
                    @click="godetail(item)"
                  >點擊進入補全商品資訊及價值
                  </md-button>
                  <div style="display: flex">
                    <md-check
                      :name="item"
                      class="checkbtn"
                      size="lg"
                      v-if="
                        (item.status == 12 || item.status == 13) &&
                        ischeck &&
                        item.auditStatus != 0
                      "
                    />
                    <div class="pckdetail" @click="godetail(item)">
                      <p>
                        快遞單號:<span v-if="item.expressCompany"
                      >{{ item.expressCompany }}-{{
                          item.expressNumber
                        }}</span
                      >
                        <span v-else>{{ item.expressNumber }}</span>
                      </p>
                      <p v-if="item.remark">
                        包裹标注:
                        <span>{{ item.remark }}</span>
                      </p>
<!--                      <div class="goodtypecontaiher">-->

<!--                      </div>-->

                      <div class="goodtypecontaiher">
                        計費重:
                        <md-amount
                          :value="item.bulk"
                          has-separator
                          style="margin-left: 0.7rem"
                        ></md-amount>
                        KG
                        <div class="packageTyps" v-if="item.type == 1" style="margin-left: 15px">
                          <span>特货</span>
                        </div>
                        <div class="packageTyp" v-if="item.type != 1" style="margin-left: 15px">
                          <span>普货</span>
                        </div>
                        <div class="packageTyps" v-if="item.goodsType" style="margin-left: 15px">
                          <span>{{ item.goodsType }}</span>
                        </div>
                      </div>
                      <p>
                        入庫時間:<span>{{
                          item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                        }}</span>
                      </p>
                      <p v-if="item.auditStatus == 0">
                        審核狀態:<span style="color: red">待審核</span>
                      </p>
                      <div class="parcel_detail_container">
                        <p>包裹明細:</p>
                        <div class="tag_container">
                          <md-tag
                            v-for="(tag, tagIndex) in item.list"
                            :key="tagIndex"
                            size="small"
                            shape="circle"
                            type="ghost"
                            font-color="#FC7353"
                          >{{ tag.name }}x{{ tag.num }}
                          </md-tag
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="packopeartion">
                    <md-button
                      type="default"
                      size="small"
                      inline
                      plain
                      style="margin: 0 0.1rem"
                      @click="returnpack(item)"
                      round
                    >退貨
                    </md-button>
                  </div>
                </md-check-group>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 3.2rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane class="contentpack" name="2" :label="items[2].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[2].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[2].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle">
                    <img
                      src="@/assets/image/icon_pack_drk.png"
                      alt=""
                      v-if="item.type == 0"
                    />
                    <div class="packageTyp" v-if="item.type == 1">
                      <span>特</span>
                    </div>
                    <span>{{ item.warehouse }}</span>
                  </div>
                  <span v-if="item.status == 21" style="color: #e51c23"
                  >[拒收]尺寸超标</span
                  >
                  <span v-if="item.status == 22" style="color: #e51c23"
                  >[拒收]包裹超重</span
                  >
                  <span v-if="item.status == 23" style="color: #e51c23"
                  >[拒收]违禁物品</span
                  >
                  <span v-if="item.status == 24" style="color: #e51c23"
                  >[拒收]涉嫌侵权</span
                  >
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <p>
                    快遞單號:<span v-if="item.expressCompany"
                  >{{ item.expressCompany }}-{{ item.expressNumber }}</span
                  >
                    <span v-else>{{ item.expressNumber }}</span>
                  </p>
                  <p v-if="item.remark">
                    包裹标注:
                    <span>{{ item.remark }}</span>
                  </p>
                  <p>
                    計費重:
                    <md-amount
                      :value="item.bulk"
                      has-separator
                      style="margin-left: 0.7rem"
                    ></md-amount>
                    KG
                  </p>
                  <p>
                    拒收時間:<span>{{
                      item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <div class="parcel_detail_container">
                    <p>包裹明細:</p>
                    <div class="tag_container">
                      <md-tag
                        v-for="(tag, tagIndex) in item.list"
                        :key="tagIndex"
                        size="small"
                        shape="circle"
                        type="ghost"
                        font-color="#FC7353"
                      >{{ tag.name }}x{{ tag.num }}
                      </md-tag
                      >
                    </div>
                  </div>
                </div>
                <div class="packopeartion">
                  <md-button
                    type="default"
                    size="small"
                    inline
                    plain
                    style="margin: 0 0.1rem"
                    @click="deletyichang(item)"
                    round
                  >删除
                  </md-button>
                </div>
                <div class="packopeartion" style="height: 0.1rem"></div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2.5rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane class="contentpack" name="3" :label="items[3].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload
            :on-infinite-load="infinite"
            :parent-pull-up-state="infiniteLoadData.pullUpState"
          >
            <div v-if="list[3].packlist.length > 0" class="packcontainer">
              <div
                v-for="(item, index) in list[3].packlist"
                :key="index"
                class="packItem"
              >
                <div class="packcompany">
                  <div class="packtitle">
                    <img
                      src="@/assets/image/icon_pack_drk.png"
                      alt=""
                      v-if="item.type == 0"
                    />
                    <div class="packageTyp" v-if="item.type == 1">
                      <span>特</span>
                    </div>
                    <span>{{ item.warehouse }}</span>
                  </div>
                  <span v-if="item.status == 31" style="color: #e51c23"
                  >已合包</span
                  >
                  <span v-if="item.status == 32" style="color: #e51c23"
                  >已销毁</span
                  >
                  <span v-if="item.status == 33" style="color: #e51c23"
                  >退货中</span
                  >
                  <span v-if="item.status == 34" style="color: #e51c23"
                  >退货完成</span
                  >
                </div>
                <div class="pckdetail" @click="godetail(item)">
                  <p>
                    快遞單號:<span v-if="item.expressCompany"
                  >{{ item.expressCompany }}-{{ item.expressNumber }}</span
                  >
                    <span v-else>{{ item.expressNumber }}</span>
                  </p>
                  <p v-if="item.remark">
                    包裹标注:
                    <span>{{ item.remark }}</span>
                  </p>
                  <p>
                    計費重:
                    <md-amount
                      :value="item.bulk"
                      has-separator
                      style="margin-left: 0.7rem"
                    ></md-amount>
                    KG
                  </p>
                  <p v-if="item.status < 21 || item.status > 24">
                    入庫時間：<span>{{
                      item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p v-if="item.status >= 21 && item.status <= 24">
                    拒收時間:<span>{{
                      item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <p style="padding-bottom: 0.1rem">
                    合包時間:<span>{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                    }}</span>
                  </p>
                  <div class="parcel_detail_container">
                    <p>包裹明細:</p>
                    <div class="tag_container">
                      <md-tag
                        v-for="(tag, tagIndex) in item.list"
                        :key="tagIndex"
                        size="small"
                        shape="circle"
                        type="ghost"
                        font-color="#FC7353"
                      >{{ tag.name }}x{{ tag.num }}
                      </md-tag
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="packopeartion" style="height: 0.1rem"></div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2.5rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
    </md-tabs>
    <md-button
      type="warning"
      style="position: fixed; bottom: 1.2rem; width: 94%; margin-left: 3%"
      v-if="current == '0'"
      @click="toprediction"
    >包裹預報
    </md-button>
    <div v-if="current == '1' && ischeck" class="bottomView">
      <div class="checkall">
        <md-icon name="check" size="lg" v-if="!checkedall" @click="checkall"/>
        <md-icon
          name="checked"
          size="lg"
          v-else
          style="color: #097ef7"
          @click="checkall"
        />
        <span @click="checkall">全选</span>
      </div>
      <div class="chelist">
        <div class="cancle">
          <p>
            合計：<span>{{ total }} KG</span>
          </p>
        </div>
       <span style="font-size: 0.22rem;color: #2a78dc" @click="handReturn">国内退货</span>
        <md-button
          :type="favorites.length > 0 ? 'warning' : 'disabled'"
          style="width: 2rem"
          @click="submit"
        >提交
        </md-button
        >
      </div>
    </div>
    <div style="width: 100%; height: 1.2rem"></div>
  </div>
</template>
<script>
import {
  Button,
  Icon,
  Tabs,
  TabPane,
  Toast,
  Check,
  CheckGroup,
  Amount,
  Dialog,
  Tag,
  DropMenu,
} from "mand-mobile";
import NothModal from "../Modal/NothModal";
import SearchModal from "../package/Modal/SearchModal";
import DropDownRefresh from "../../components/refresh";
import PullUpReload from "../../components/pullDown";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Amount.name]: Amount,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Check.name]: Check,
    [CheckGroup.name]: CheckGroup,
    [Tag.name]: Tag,
    [DropMenu.name]: DropMenu,
    SearchModal,
    "v-refresh": DropDownRefresh,
    "v-reload": PullUpReload,
    NothModal,
  },
  name: "Package",
  data() {
    return {
      inStatus: '',
      favorites: [], // 选中包裹合单
      checkedall: false, // 是否全选
      total: 0.0, // 总计
      ischeck: true,
      infiniteLoadData: {
        initialShowNum: 200, // 初始显示多少条
        everyLoadingNum: 200, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum, // 上拉加载后所展示的个数
      },
      isFinished: false,
      current: "0",
      pagenum: 1,
      indename: "0",
      list: [
        {packlist: []},
        {packlist: []},
        {packlist: []},
        {packlist: []},
      ],
      items: [
        {name: 0, label: "待入庫"},
        {name: 1, label: "已入庫"},
        {name: 2, label: "异常"},
        {name: 3, label: "歷史"},
      ],
      // 仓库列表
      warehouses: [
        {
          text: "",
          options: [],
        }, {
          text: "",
          options: [],
        },
      ],
      selected_wareHouse: "",
    };
  },
  activated() {
    localStorage.removeItem("serfren");
    if (
      localStorage.getItem("fleshpack") &&
      this.$route.query.id == undefined
    ) {
      this.pagenum = 1;
      this.parcelsimpleStatus(null);
    } else if (
      localStorage.getItem("fleshpack") &&
      this.$route.query.id != undefined
    ) {
      this.current = this.$route.query.packindecx;
      this.indename = this.$route.query.packindecx;
      this.pagenum = 1;
      this.parcelsimpleStatus(null);
    } else if (
      !localStorage.getItem("fleshpack") &&
      this.$route.query.id != undefined
    ) {
      if (this.current != this.$route.query.packindecx) {
        this.current = this.$route.query.packindecx;
        this.indename = this.$route.query.packindecx;
        this.pagenum = 1;
        this.parcelsimpleStatus(null);
      }
    }
  },
  watch: {
    favorites: function (newVal) {
      console.log(newVal);
      // 合计总费用111
      this.total = this.sum(newVal);
      // 全选命中
      if (
        (newVal.length !== 0) &&
        (newVal.length === this.list[this.current].packlist.length)
      ) {
        this.checkedall = true;
      } else {
        this.checkedall = false;
      }
    },
  },
  methods: {
    lanjie(item) {
      Dialog.confirm({
        content: "通知倉庫攔截並拒收該包裹，是否確認操作？",
        confirmText: "確定",
        onConfirm: () => this.parcelRejection(item.id),
      });
    },
    chenkjfr(item) {
      Dialog.confirm({
        content: "撤銷後包裹可以正常入庫，確定撤銷此拒收嗎？",
        confirmText: "確定",
        onConfirm: () => this.parcelCancelRejection(item.id),
      });
    },
    deletyichang(item) {
      Dialog.confirm({
        content: "删除後包裹將被隱藏，確認删除嗎？",
        confirmText: "確定",
        onConfirm: () => this.deltyi(item.id),
      });
    },
    deltyi(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.deleteException, "post", par)
        .then((res) => {
          this.parcelsimpleStatus(null);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    parcelCancelRejection(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.parcelCancelRejection, "get", par)
        .then((res) => {
          this.parcelsimpleStatus(null);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    parcelRejection(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.parcelRejection, "get", par)
        .then((res) => {
          this.parcelsimpleStatus(null);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    lookwu(item) {
      this.$router.push({
        name: "PackLogin",
        query: {
          expressNumber: item.expressNumber,
          expressCompany: item.expressCompany,
        },
      });
    },
    returnpack(item) {
      let usejr=[]
      usejr[0]=item
      this.$router.push({
        name: "ReturnAddress",
        query: {
          des: JSON.stringify(usejr),
        },
      });
    },
    handReturn(){

      if(this.favorites.length<1){
        Toast.failed("请选择退货包裹");
        return
      }
      this.$router.push({
        name: "ReturnAddress",
        query: {
          des: JSON.stringify(this.favorites),
        },
      });
    },
    // 合并提交
    submit() {
      var json = this.favorites[0];
      var list = [];
      var item = this.favorites.map((val) => {
        if (json.warehouse != val.warehouse) {
          list.push(val);
        }
      });

      if (list.length > 0) {
        Toast.failed("不同倉庫的包裹不能合包");
        return;
      }
      this.ajcon
        .AJcon(this.ports.getMaxParcelNumByCountry, "post")
        .then((res) => {
          if (this.favorites.length > res) {
            Toast.failed("最大合包数不能超过" + res + "个");
          } else {
            Dialog.confirm({
              content: "您確定要合併發貨？",
              confirmText: "確定",
              onConfirm: () => this.allsubmit(),
            });
          }
          console.log(res);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    allsubmit() {
      var list = [];
      var item = this.favorites.map((val) => {
        list.push(val.id);
      });
      localStorage.setItem("addorder", 1);
      this.$router.push({
        name: "Orderpack",
        query: {ids: JSON.stringify(list)},
      });
    },
    // 全选
    checkall() {
      this.checkedall = !this.checkedall;
      if (this.checkedall) {
        var list = [];
        var item = this.list[1].packlist.map((val) => {
          if ((val.status == 12 || val.status == 13) && val.auditStatus != 0) {
            list.push(val);
          }
        });
        console.log(list);
        this.favorites = list;
        this.total = this.sum(newVal);
      } else {
        this.favorites = [];
      }
    },
    parcelsimpleStatus(opear) {
      localStorage.removeItem("fleshpack");
      this.http
        .APIASK(this.ports.parcelsimpleStatus, "get")
        .then((res) => {
          res["0"] > 0
            ? (this.items[0].label = "待入庫" + res["0"])
            : (this.items[0].label = "待入庫"),
            res["1"] > 0
              ? (this.items[1].label = "已入庫" + res["1"])
              : (this.items[1].label = "已入庫"),
            res["2"] > 0
              ? (this.items[2].label = "异常" + res["2"])
              : (this.items[2].label = "异常"),
            res["3"] > 0
              ? (this.items[3].label = "歷史" + res["3"])
              : (this.items[3].label = "歷史"),
            this.getlist(opear);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    toserch() {
      this.$router.push({name: "PackSearch"});
    },
    godetail(item) {
      this.$router.push({
        name: "Packdetail",
        query: {id: item.id, status: item.status},
      });
    },
    getallcheck(item) {
      var fitervalue = this.favorites.findIndex((value, index, arr) => {
        return item.id == value.id;
      });
      if (fitervalue === -1) {
        this.favorites.push(item);
        var list = [];
        var items = this.list[1].packlist.map((val) => {
          if ((val.status == 12 || val.status == 13) && val.auditStatus != 0) {
            list.push(val);
          }
        });
        list.length == this.favorites.length ? this.checkedall = true : this.checkedall = false;
      } else {
        this.favorites.splice(fitervalue, 1);
        this.checkedall = false;
      }
    },
    // tab切换
    changetable(item, index) {
      // 重置仓库选择
      this.selected_wareHouse = "";
      this.warehouses = [
        {
          text: "",
          options: [],
        }, {
          text: "",
          options: [],
        },
      ];
      this.current = item.name;
      this.pagenum = 1;
      this.infiniteLoadData.pullUpList = [];
      this.infiniteLoadData.pullUpState = 4;
      this.parcelsimpleStatus(null);
    },
    delet(item, indx) {
      Dialog.confirm({
        content: "您確定要删除該包裹嗎",
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id,
          };
          this.http
            .APIASK(this.ports.parceldelete, "post", par)
            .then((res) => {
              this.parcelsimpleStatus(null);
              Toast.succeed("删除成功");
            })
            .catch((err) => {
            });
        },
      });
    },
    onRefreshone(done) {
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      const scrollHeight =
        document.documentElement.clientHeight || document.body.scrollHeight;
      console.log(scrollHeight);
      console.log(scrollTop);
      if (this.infiniteLoadData.pullUpState === 0) {
        this.infiniteLoadData.pullUpList = [];
        this.pagenum = 1;
        this.parcelsimpleStatus(null);
        done();
      } else {
        done();
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    // 上拉加载
    infinite(done) {
      if (this.infiniteLoadData.pullUpState === 1) {
        this.pagenum++;
        this.getlist("load");
        done();
      } else {
        done();
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    changeWareHouse(barItem, listItem) {
      Toast.loading("请稍等...");
      console.log(listItem.value)
      if (listItem.value != '') {
        if (isNaN(parseInt(listItem.value))) {
          console.log(123)
          this.selected_wareHouse = listItem.value;

        } else {
          console.log(321)
          this.inStatus = listItem.value
        }
      } else {
        this.inStatus = ''
      }
      this.getlist();
    },

    getlist(opear) {
      this.infiniteLoadData.pullUpState = 0;
      const par = {
        keyword: "",
        pageNum: this.pagenum,
        pageSize: 200,
        sort: false,
        status: this.current,
        inStatus: this.inStatus,
        warehouse: this.selected_wareHouse
          ? this.selected_wareHouse
          : undefined,
      };

      // console.log(this.selected_wareHouse)
      // if(this.warehouses.options.length > 0 && this.selected_wareHouse) {
      //   par.warehouse = this.selected_wareHouse
      // }

      this.http
        .APIASK(this.ports.parcellist, "get", par)
        .then((res) => {
          Toast.hide();
          // pullUpState: 0, 1:上拉加载更多, 2:加载中……, 3:我是有底线的
          if (opear) {
            // console.log("上拉加载")
            if (res.list.length > 0) {
              this.list[this.current].packlist = this.list[
                this.current
                ].packlist.concat(res.list);
              this.infiniteLoadData.pullUpList =
                this.list[this.current].packlist;
              if (res.list.length < 200) {
                this.infiniteLoadData.pullUpState = 3;
              } else {
                this.infiniteLoadData.pullUpState = 1;
              }
            } else {
              this.infiniteLoadData.pullUpState = 3;
            }
          } else {
            // console.log("下拉刷新")
            this.checkedall = false;
            this.total = 0.0;
            this.favorites = [];
            if (res.list.length < 200) {
              this.infiniteLoadData.pullUpState = 3;
            } else {
              this.infiniteLoadData.pullUpState = 1;
            }
            this.list[this.current].packlist = res.list;
            // console.log(
            //   this.infiniteLoadData.pullUpState,
            //   this.list[this.current].packlist
            // );
            this.infiniteLoadData.pullUpList = this.list[this.current].packlist;
          }
          this.list[this.current].packlist.length < 200
            ? (this.infiniteLoadData.pullUpState = 0)
            : null;

          // 仓库筛选
          let list = [
            {
              text: "仓库筛选",
              options: [
                {
                  value: undefined,
                  text: "全部",
                },
              ],
            },
            {
              text: "全部",
              options: [
                {
                  value: '',
                  text: "全部",
                },
                {
                  value: '11',
                  text: "待补完",
                }, {
                  value: '12',
                  text: "待合包",
                }, {
                  value: '13',
                  text: "超期",
                },
              ],
            },
          ];
          for (let i in res.warehouses) {
            let arr = {
              value: res.warehouses[i],
              text: res.warehouses[i],
            };
            list[0].options.push(arr);
          }
          this.warehouses = list;

          Toast.hide();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    detail(item) {
      this.$router.push({
        name: "Predition",
        query: {id: item.countryId, item: JSON.stringify(item)},
      });
    },
    sum(arr) {
      var s = 0;
      arr.forEach(function (val, idx, arr) {
        s += val.bulk;
      }, 0);
      return s.toFixed(2);
    },
    getStartPullUpState() {
      if (this.infiniteLoadData.pullUpList.length) {
        if (
          this.list[this.current].packlist.length <=
          this.infiniteLoadData.initialShowNum
        ) {
          // 修改子组件的pullUpState状态
          this.infiniteLoadData.pullUpState = 3;
        } else {
          this.infiniteLoadData.pullUpState = 1;
        }
      } else {
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    toprediction() {
      this.$router.push({
        name: "Predition",
        query: {
          id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id,
        },
      });
    },
  },
  mounted() {
    this.$refs.search.message = "快遞單號";
    this.parcelsimpleStatus(null);
  },
};
</script>

<style lang="less">
.allpage {
}

.md-tab-bar {
  position: fixed;
  top: 1rem;
  z-index: 999;
  width: 100%;
  padding: 0;
  font-size: 0.24rem;
}

.md-tab-bar-item.is-active {
  color: #e32c1a;
}

.md-tab-bar-ink {
  background-color: #e32c1a;
}

.packItem {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
  margin-bottom: 0.1rem;
  border-radius: 0.1rem;
  width: 94%;
  margin-left: 3%;

  .packcompany {
    width: 100%;
    height: 0.6rem;
    display: flex;
    align-items: center;
    font-size: 0.28rem;
    justify-content: space-between;
    border-bottom: 1px solid #e2e4ea;

    .packtitle {
      height: 100%;
      display: flex;
      align-items: center;

      img {
        width: 0.3rem;
        margin: 0 0.1rem;
      }
    }

    span {
      margin-right: 0.1rem;
    }
  }

  .pckdetail {
    padding: 0 0.2rem;
    font-size: 0.28rem;

    p {
      text-align: left;
      margin: 0.1rem 0;
      text-align: left;
      span {
        margin-left: 0.1rem;
      }
    }
  }

  .packopeartion {
    width: 100%;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.packageTyp {
  padding: 0.04rem 0.11rem;
  border-radius: 0.07rem;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(82, 204, 111, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.2rem 0 0;

  span {
    margin: 0 !important;
  }
}

.goodtypecontaiher {
  display: flex;
  align-items: center;
}

.packageTyps {
  height: 0.35rem;
  padding: 0 0.1rem;
  border-radius: 0.07rem;
  color: #307dfd;
  border: 1px solid #307dfd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.2rem;

  span {
    margin: 0 !important;
  }
}

.checkbtn {
  margin-left: 0.2rem;

  .md-check-icon {
    font-size: 0.7rem;
  }
}

.bottomView {
  position: fixed;
  width: 100%;
  height: 1rem;
  bottom: 1rem;
  margin-bottom: 0.2rem;
  background-color: white !important;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .checkall {
    height: 100%;
    display: flex;
    align-items: center;
    width: 20%;
    margin-left: 4%;

    span {
      margin-left: 0.1rem;
      font-size: 0.3rem;
    }
  }

  .chelist {
    width: 80%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cancle {
    font-size: 0.3rem;

    p {
      span {
        color: #e51c23;
        margin-right: 0.1rem;
      }
    }
  }
}

.parcel_detail_container {
  border-top: 1px solid #e2e4ea;
  border-bottom: 1px solid #e2e4ea;
 display: flex;
  flex-wrap: wrap;
  align-items: center;
  .tag_container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .md-tag {
      margin-left: 0.1rem;
    }
  }
}

// 仓库筛选下拉
.contentpack .md-drop-menu {
  height: auto;
  box-sizing: border-box;
  color: #666f83;
  font-size: 0.3rem;
  font-weight: 500;
  position: relative;
  margin: 0 0.2rem 0.1rem 0.2rem;
  text-align: right;

  .md-drop-menu-list {
    padding-top: 0.65rem !important;
  }

  .md-popup {
    top: 1rem !important;
  }

  .md-drop-menu-bar .bar-item.selected {
    color: #e51c23 !important;
  }
}
</style>
